import * as React from "react";
function SvgIcArrowLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.999 5L4 12l3.999 7 .639-.373-3.573-6.254H20v-.746H5.065l3.573-6.254L7.998 5z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcArrowLeft;
